'use client';

import { createContext, useContext, type ReactNode } from 'react';

/**
 * The IANA zone every datetime inside this subtree is displayed in, or `null`
 * for the site default (the viewer's browser zone after mount, UTC before it).
 *
 * Set from `event.timezone` on the public event pages so a bracket, match list
 * or schedule reads in venue time no matter where the viewer is. Both display
 * rails — `<LocalDateTime>` and `useHydratedTimeZone()` — resolve through
 * {@link useDisplayTimeZone}, so a provider is the only per-event wiring.
 */
const DisplayTimeZoneContext = createContext<string | null>(null);

export function DisplayTimeZoneProvider({
  timeZone,
  children,
}: {
  timeZone: string | null | undefined;
  children: ReactNode;
}) {
  return (
    <DisplayTimeZoneContext.Provider value={timeZone ?? null}>
      {children}
    </DisplayTimeZoneContext.Provider>
  );
}

/** The pinned display zone, or `null` when times follow the viewer. */
export function useDisplayTimeZone(): string | null {
  return useContext(DisplayTimeZoneContext);
}
